import styled from "styled-components";
import Link from "../../../../../../../components/Link";
import Button from "../../../../../../../components/Button";
import SubmitUi from '../../../../../../../components/FormikForm/Submit'

export const Title = styled.h2`
  font-weight: 500;
  font-size: 18px;
  line-height: normal;
  color: #2D3436;
  margin: 0px;
  text-align: center;
`;

export const Text = styled.p`
  font-size: 14px;
  line-height: normal;
  color: #2D3436;
  margin: 0px;
  text-align: center;
`;

export const SmallText = styled.p`
  font-size: 12px;
  line-height: normal;
  color: #2D3436;
  margin: 0px;
  text-align: center;
`;

export const SuccessIcon = styled.div`
  width: 96px;
  height: 96px;
  border-radius: 50%;
  background: #d3f2d3;
  border: 1px solid #4CA154;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    color: #4caf50;
    width: 48px;
    height: 48px;
  }
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  width: 100%;
  
  @media(min-width: 768px){
    flex-direction: row;
    justify-content: flex-end;
  }
`;

export const Continue = styled(Link)`
  font-size: 16px;
  margin: 0;
  border-radius: 20px;
  font-weight: 500;
  line-height: 36px;
  height: 40px;
`;

export const Submit = styled(SubmitUi)`
  font-size: 16px;
  margin: 0;
  border-radius: 20px;
  font-weight: 500;
  line-height: 36px;
  height: 40px;
`;

export const Close = styled(Button)`
  font-size: 16px;
  margin: 0;
  border-radius: 20px;
  font-weight: 500;
  line-height: 36px;
  height: 40px;
`;


export const Cancel = styled(Button)`
  font-size: 16px;
  margin: 0;
  border-radius: 20px;
  font-weight: 500;
  line-height: 36px;
  height: 40px;
`;


export const Flex = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
`